// extracted by mini-css-extract-plugin
module.exports = {"contentDisplay":"SearchResult_contentDisplay__1_yD8","disabled":"SearchResult_disabled__2O0fB"};